/**
 * useKeyboardHeight.js — Track iOS keyboard height via Capacitor Keyboard plugin
 *
 * On native iOS with Capacitor Keyboard resize:'none', the webview doesn't
 * shrink when the keyboard opens. This hook listens to keyboardWillShow/Hide
 * events to report the keyboard height so components can adjust their layout.
 *
 * Returns 0 on web or when keyboard is hidden.
 */

import { useState, useEffect } from 'react';

export function useKeyboardHeight() {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    let showListener = null;
    let hideListener = null;

    async function setup() {
      try {
        if (!window.Capacitor?.isNativePlatform?.()) return;
        const { Keyboard } = await import('@capacitor/keyboard');
        showListener = await Keyboard.addListener('keyboardWillShow', (info) => {
          setKeyboardHeight(info.keyboardHeight);
        });
        hideListener = await Keyboard.addListener('keyboardWillHide', () => {
          setKeyboardHeight(0);
        });
      } catch {
        // Not on native or plugin not available
      }
    }
    setup();
    return () => {
      showListener?.remove?.();
      hideListener?.remove?.();
    };
  }, []);

  return keyboardHeight;
}
